import { ErrorMessageContents } from '../../../helpers/hub'
import { SystemParam } from './types'

export const systemParamFetch = () => ({ type: 'sysparam.fetch' } as const)
type SystemParamFetchAction = ReturnType<typeof systemParamFetch>

export const systemParamFetchCancel = () =>
  ({ type: 'sysparam.fetchCancel' } as const)
export type SystemParamFetchCancelAction = ReturnType<
  typeof systemParamFetchCancel
>

export const addSystemParam = (systemParams: SystemParam[]) =>
  ({ type: 'sysparam.addSystemParams', payload: systemParams } as const)
export type SystemParamAddSystemParamAction = ReturnType<typeof addSystemParam>

export const systemParamFetchFail = (error: ErrorMessageContents) =>
  ({ type: 'sysparam.fetchFail', payload: error, error: true } as const)
export type SystemParamFetchFailAction = ReturnType<typeof systemParamFetchFail>

export const saveSystemParam = (param: SystemParam) =>
  ({ type: 'sysparam.saveSystemParam', payload: param } as const)
export type SystemParamSaveAction = ReturnType<typeof saveSystemParam>

export const saveSystemParamSuccess = (
  systemParamList: SystemParam,
  transactionId?: number
) =>
  ({
    type: 'sysparam.saveSystemParamSuccess',
    payload: { systemParamList, transactionId }
  } as const)
export type SaveSystemParamSuccessAction = ReturnType<
  typeof saveSystemParamSuccess
>

export const saveSystemParamFailure = (error: ErrorMessageContents) =>
  ({
    type: 'sysparam.saveSystemParamFailure',
    payload: error,
    error: true
  } as const)
export type SaveSystemParamFailureAction = ReturnType<
  typeof saveSystemParamFailure
>

export const deleteSystemParams = (params: SystemParam[]) =>
  ({ type: 'sysparam.deleteSystemParams', payload: params } as const)
export type SystemParamsDeleteAction = ReturnType<typeof deleteSystemParams>

export const deleteSystemParamsSuccess = (systemParamList: SystemParam[]) =>
  ({
    type: 'sysparam.deleteSystemParamsSuccess',
    payload: { systemParamList }
  } as const)
export type DeleteSystemParamsSuccessAction = ReturnType<
  typeof deleteSystemParamsSuccess
>

export const deleteSystemParamsFailure = (error: ErrorMessageContents) =>
  ({
    type: 'sysparam.deleteSystemParamsFailure',
    payload: error,
    error: true
  } as const)
export type DeleteSystemParamsFailureAction = ReturnType<
  typeof deleteSystemParamsFailure
>

export const systemParamChangeConfirmed = () =>
  ({ type: 'sysparam.changeConfirmed' } as const)
export type SystemParamChangeConfirmedAction = ReturnType<
  typeof systemParamChangeConfirmed
>

export const systemParamChangeTimedOut = () =>
  ({ type: 'sysparam.changeTimedOut' } as const)
export type SystemParamChangeTimedOutAction = ReturnType<
  typeof systemParamChangeTimedOut
>

export type SystemParamAction =
  | SystemParamFetchAction
  | SystemParamAddSystemParamAction
  | SystemParamFetchFailAction
  | SystemParamSaveAction
  | SaveSystemParamSuccessAction
  | SaveSystemParamFailureAction
  | SystemParamsDeleteAction
  | DeleteSystemParamsSuccessAction
  | DeleteSystemParamsFailureAction
  | SystemParamFetchCancelAction
  | SystemParamChangeConfirmedAction
  | SystemParamChangeTimedOutAction
